// extracted by mini-css-extract-plugin
export var button = "_gb-4";
export var hasDarkBackground = "_gb-7";
export var hasLightBackground = "_gb-6";
export var iconWrapper = "_gb-0";
export var large = "_gb-2";
export var medium = "_gb-1";
export var small = "_gb-5";
export var xsmall = "_gb-3";